import { cacheFirstConfig, http } from '@/core/helpers/axiosHelper';
import { LocationQuery } from 'vue-router';
import { Salutation } from './salutation.interface';

export class SalutationService {
   async getSaltutations(query?: LocationQuery) {
      const response = await http.get<Array<Salutation>>(`/salutations`, { ...cacheFirstConfig, params: { ...query } });
      return response.data;
   }
}
